/**
 * @file: datetime.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import differenceInSeconds from 'date-fns/differenceInSeconds';
import format from 'date-fns/format';
import toDate from 'date-fns/toDate';
import { dateFromString } from '../datetime';

const kSecondsPerHour = 3600;

export function formatDate(
  date: string | Date | number,
  dateFormat = 'yyyy-MM-dd',
) {
  const instance =
    typeof date === 'string' ? dateFromString(date) : toDate(date);
  return format(instance, dateFormat);
}

export const defaultFormatDateTime = (date: string | Date | number) =>
  formatDateTime(date);

export function formatDateTime(
  date: string | Date | number,
  dateTimeFormat = 'yyyy-MM-dd HH:mm',
) {
  //Fix: use try catch to avoid web page crash
  try {
    const instance =
      typeof date === 'string' ? dateFromString(date) : toDate(date);
    return format(instance, dateTimeFormat);
  } catch (err) {
    console.error(`invalid time: ${date}`, err);
    return String(date);
  }
}

export const timeUtilNow = (
  value: string | Date | number,
  dateTimeFormat = 'yyyy-MM-dd HH:mm',
) => {
  const date =
    typeof value === 'string' ? dateFromString(value) : new Date(value);
  let sec = differenceInSeconds(Date.now(), date);
  let day = 0,
    hour = 0,
    min = 0;
  day = Math.floor(sec / (kSecondsPerHour * 24));
  sec -= day * (kSecondsPerHour * 24);
  hour = Math.floor(sec / kSecondsPerHour);
  sec -= hour * kSecondsPerHour;
  min = Math.floor(sec / 60);
  sec -= min * 60;
  if (day > 7) {
    return format(date, dateTimeFormat);
  }
  if (day > 0) {
    return `${day}天前`;
  }
  if (hour > 0) {
    return `${hour}小时前`;
  }
  if (min > 0) {
    return `${min}分钟前`;
  }
  if (sec >= 30) {
    return `${sec}秒前`;
  }
  return '刚刚';
};
